import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';

export const PHASER_SLICE_KEY = 'phaser';

export interface PointerEventPayload {
  x: number;
  y: number;
}

export interface PhaserSliceState {
  sceneReady: string | null;
  lastPointerDown: PointerEventPayload | null;
}

const initialState: PhaserSliceState = {
  sceneReady: null,
  lastPointerDown: null,
};

const phaserSlice = createSlice({
  name: PHASER_SLICE_KEY,
  initialState,
  reducers: {
    setSceneReady: (state, action: PayloadAction<string>) => {
      state.sceneReady = action.payload;
    },
    setPointerDown: (state, action: PayloadAction<PointerEventPayload>) => {
      state.lastPointerDown = action.payload;
    },
  },
});

const phaserReducer = phaserSlice.reducer as Reducer;
export default phaserReducer;
export const phaserActions = phaserSlice.actions;
export const phaserSelector = (state: {
  [PHASER_SLICE_KEY]: PhaserSliceState;
}) => state[PHASER_SLICE_KEY];
